var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRbacRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4593 12.4492C13.743 12.8972 12.9053 13.1667 12 13.1667C11.0946 13.1667 10.257 12.8972 9.54064 12.4492C7.08481 13.3615 5.28114 15.5992 5.03147 18.3642C5.01631 18.5275 5.07114 18.6885 5.18197 18.8098C5.29281 18.9312 5.44914 19 5.61247 19H18.3875C18.552 19 18.7071 18.9312 18.818 18.8098C18.9288 18.6885 18.9836 18.5263 18.9685 18.3642C18.7188 15.5992 16.9151 13.3615 14.4593 12.4492Z",
    fill: "#797B80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.933 12 15.5 10.433 15.5 8.5C15.5 6.567 13.933 5 12 5C10.067 5 8.5 6.567 8.5 8.5C8.5 10.433 10.067 12 12 12Z",
    fill: "#797B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbacRole);
export default __webpack_public_path__ + "static/media/rbac-role.8adec8c0d723a4356308ec7ddb6e0d2f.svg";
export { ForwardRef as ReactComponent };